export default [{
        path: '/room/index',
        name: 'roomindex',
        component: resolve => require(['@/components/room/index.vue'], resolve),
        meta: {
            title: '展厅首页'
        }
    },
    {
        path: '/room/company',
        name: 'roomcompany',
        component: resolve => require(['@/components/room/company.vue'], resolve),
        meta: {
            title: '公司简介'
        }
    },
    {
        path: '/room/contactus',
        name: 'roomcontactus',
        component: resolve => require(['@/components/room/contactus.vue'], resolve),
        meta: {
            title: '联系我们'
        }
    },
    // {
    //     path: '/room/news',
    //     name: 'roomnews',
    //     component: resolve => require(['@/components/room/news.vue'], resolve),
    //     meta: {
    //         title: '企业新闻'
    //     }
    // },
    // {
    //     path: '/room/newsDetails',
    //     name: "newsdetails",
    //     component: resolve => require(['@/components/room/newsDetails.vue'], resolve),
    //     meta: {
    //         title: '新闻详情'
    //     }
    // },
    {
        path: '/room/storageTrade',
        name: 'storagetrade',
        component: resolve => require(['@/components/room/storageTrade.vue'], resolve),
        meta: {
            title: '货源交易'
        }
    },
    {
        path: '/room/goodsDetails',
        name: 'goodsdetails',
        component: resolve => require(['@/components/room/goodsDetails.vue'], resolve),
        meta: {
            title: '货源交易详情'
        }
    },
    {
        path: '/room/logisticsParkDetails',
        name: 'logisticsparkdetails',
        component: resolve => require(['@/components/room/logisticsParkDetails.vue'], resolve),
        meta: {
            title: '物流园区详情'
        }
    },
    {
        path: '/room/logisticsLineDetails',
        name: 'logisticslinedetails',
        component: resolve => require(['@/components/room/logisticsLineDetails.vue'], resolve),
        meta: {
            title: '物流专线详情'
        }
    },
    {
        path: '/room/storageLogistics',
        name: 'storagelogistics',
        component: resolve => require(['@/components/room/storageLogistics.vue'], resolve),
        meta: {
            title: '仓储物流'
        }
    },
    {
        path: '/room/storagePark',
        name: 'storagepark',
        component: resolve => require(['@/components/room/storagePark.vue'], resolve),
        meta: {
            title: '物流园区'
        }
    },
    {
        path: '/room/storageLine',
        name: 'storageline',
        component: resolve => require(['@/components/room/storageLine.vue'], resolve),
        meta: {
            title: '专线资源'
        }
    },
    {
        path: '/room/logisticsstorageDetails',
        name: 'logisticsstoragedetails',
        component: resolve => require(['@/components/room/logisticsstorageDetails.vue'], resolve),
        meta: {
            title: '仓储物流详情'
        }
    },
    {
        path: '/room/storageJobs',
        name: 'storagejobs',
        component: resolve => require(['@/components/room/storageJobs.vue'], resolve),
        meta: {
            title: '招聘信息'
        }
    },
    {
        path: '/room/jobsDetail',
        name: 'jobsdetail',
        component: resolve => require(['@/components/room/jobsDetail.vue'], resolve),
        meta: {
            title: '招聘信息详情'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/roomRouter.js